export function isPatternAttemptCorrect(question, attempt) {
  if (question?.interaction === 'direct_select') {
    return Number(attempt?.target_index) === Number(question?.correct_target_index);
  }
  return String(attempt?.choice_id || '') === String(question?.correct_choice_id || '');
}

export function patternRecognitionRoundResult(questions, responses) {
  const correctCount = responses.reduce((total, response, index) => {
    const attempt = response?.attempts?.[0];
    return total + (attempt && isPatternAttemptCorrect(questions[index], attempt) ? 1 : 0);
  }, 0);
  const answeredCount = responses.reduce((total, response) => total + Number(Boolean(response?.attempts?.length)), 0);
  return {
    correct_count: correctCount,
    wrong_count: questions.length - correctCount,
    answered_count: answeredCount,
    unanswered_count: questions.length - answeredCount,
    passed: correctCount >= 4,
  };
}

export function patternRecognitionPreviewSummary(questionRounds, rounds) {
  const roundResults = rounds.map((roundResult, index) => ({
    round_number: index + 1,
    ...patternRecognitionRoundResult(questionRounds[index] || [], roundResult.responses || []),
  }));
  const correctCount = roundResults.reduce((total, result) => total + result.correct_count, 0);
  const questionCount = roundResults.length * 5;
  const totalAttemptCount = rounds.reduce(
    (total, roundResult) => total + (roundResult.responses || []).filter((response) => response.attempts?.length).length,
    0,
  );
  const passed = roundResults.length === 1 && Boolean(roundResults[0]?.passed);
  return {
    preview: true,
    task_type: 'pattern_recognition',
    round_results: roundResults,
    round_count: roundResults.length,
    question_count: questionCount,
    correct_count: correctCount,
    wrong_count: questionCount - correctCount,
    first_attempt_correct_count: correctCount,
    retry_count: 0,
    total_attempt_count: totalAttemptCount,
    score_pct: questionCount ? Math.round((correctCount / questionCount) * 100) : 0,
    passed,
    rounds_remaining: 0,
    next_prompt: passed ? 'Harika, turu başarıyla tamamladın!' : 'Bu leveli tekrar deneyelim.',
  };
}
